@value headerHeight: 54px;
@value wrapperPadding: 12px;

.settings-page-wrapper {
    background-color: var(--skeleton-grey);
    padding: wrapperPadding wrapperPadding 0 wrapperPadding;
    height: calc(100% - headerHeight - wrapperPadding);
}

.inner-content {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    background-color: var(--white);
    height: 100%;
}
